import * as React from 'react';
import cn from 'classnames';

import { Props } from '@websky/core/src/DesktopFlightRoute/components/Segment/renderers';
import Amenities from '@websky/core/src/Amenities';
import { useTheme } from '@websky/core/src/theme';
import * as css from './SegmentPlaneInfo.css';

const SegmentPlaneInfo: React.FC<Props> = ({ className, segment }) => {
	const { SegmentStyles: theme } = useTheme('DesktopFlightRoute');

	console.log(segment);

	return (
		<div className={cn(className, theme.planeInfo)}>
			{segment.marketingAirline?.icon && <img className={css.icon} src={segment.marketingAirline.icon} />}

			<div className={css.info}>
				<div>
					{segment.operatingAirline.name}, рейс {segment.operatingAirline.iata}-{segment.flightNumber}
				</div>

				<div>
					<span>{segment.aircraft.name}</span>
					{segment?.flightInfo?.amenities && <Amenities amenities={segment.flightInfo.amenities} />}
				</div>
			</div>
		</div>
	);
};

export default SegmentPlaneInfo;
